import qs from "qs";
import axios from "axios";

export const saveOnboarding = async (step, data, isCreate) => {
    switch (step) {
        case 0 :
            saveOrgInfo(data, isCreate)
            break
        case 1:
            saveUsers(data)
            break
        default:
            // nothing for now
            break
    }
}

export const saveUsers = async (data) => {
    const transformedData = {
        userInformation: data
    }
    try {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: {'content-type': 'application/json'},
            data: JSON.stringify(transformedData),
            url: `${process.env.REACT_APP_BASE_SERVER}/new/client/users`
        };

        const response = await axios(options)
    } catch (error) {
        console.error('Error saveOnboarding users:', error);
        throw new Error(error.response.data.message || 'Failed to save user data');
    }
}

export const saveOrgInfo = async (data, isCreate = false) => {
    const transformedData = {
        isCreate: isCreate,
        organizationInformation: {
            industryId: data.industryId.id,
            companyId: {id: data.companyId.id, label: data.companyId.label},
            address: data.address,
            hasSubsidiaries: data.hasSubsidiaries,
            subsidiaryList: data.subsidiaryList,
            employeeCount: data.employeeCount,
            boundary: data.boundary,
            province: {id:data.province.id, label: data.province.label},
            city: {id:data.city.id, label: data.city.label},
        },
    };
    try {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: {'content-type': 'application/json'},
            data: JSON.stringify(transformedData),
            url: `${process.env.REACT_APP_BASE_SERVER}/new/client`
        };

        const response = await axios(options)

    } catch (error) {
        console.error('Error saveOnboarding:', error);
        throw new Error(error.response.data.message || 'Failed to save data');
    }
}

export const finishOnboard = async () => {
    try {
        const options = {
            withCredentials: true,
            method: 'POST',
            url: `${process.env.REACT_APP_BASE_SERVER}/finish-onboard`
        };

        const response = await axios(options)

        if (response.data.success) {
            return response.data.data
        }
    } catch (error) {
        console.error('Error finishOnboard:', error);
        throw new Error(error.response.data.message || 'Failed to finish Onboard');
    }
}

export const getOrganizationalInformation = async () => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/organizational/information`,
        };

        const response = await axios(options);

        if (response.data.success) {
            return response.data.data
        }
        return {"organizationInformation": {}};
    } catch (error) {
        console.error('Error fetching getOrganizationalInformation:', error);
        throw new Error(error.response.data.message || 'Failed to fetch organizational information');
    }
}

export const getUserInformation = async () => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/users/information`,
        };

        const response = await axios(options);

        if (response.data.success) {
            return response.data.data
        }
        return {"userInformation": {}};
    } catch (error) {
        console.error('Error fetching getUserInformation:', error);
        throw new Error(error.response.data.message || 'Failed to fetch user information');
    }
}

export const finishTour = async (tourName) => {
    try {
        const options = {
            withCredentials: true,
            method: 'POST',
            data: {
                tourName: tourName,
            },
            url: `${process.env.REACT_APP_BASE_SERVER}/finish-tour`,
        };

        const response = await axios(options);

    } catch (error) {
        console.error('Error finishTour:', error);
    }
}
